export default __webpack_public_path__ + "static/media/clock-1.a42abd6a.svg";